import React from 'react'
import './Banner.css'


function Banner() {
  return (
    <div>
      <section className='video-container'>
        <video src='/Videos/video.mp4' loop autoPlay />
        <div className='overlay'></div>
      </section>
    </div>
  )
} 

export default Banner
